module.exports = __webpack_public_path__ + "img/s5.e93fa92e.svg";